import { Page } from '@/components';
import { DropdownFilter, useTableProps } from '@blockanalitica/ui';
import MarketsTable from '../MarketsTable';

const APY_OPTIONS = [
  {
    value: '',
    label: 'Current APY'
  },
  {
    value: '_1d',
    label: '1D AVG APY'
  },
  {
    value: '_7d',
    label: '7D AVG APY'
  },
  {
    value: '_30d',
    label: '30D AVG APY'
  },
  {
    value: '_90d',
    label: '90D AVG APY'
  },
  {
    value: '_365d',
    label: '1Y AVG APY'
  }
];

export default function MarketsPage() {
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 20,
    initialSorting: '-total_supply_usd',
    filtersDebounceTime: 500,
    initialFilters: {
      selectedOption: ''
    }
  });

  return (
    <Page
      title="Markets"
      actions={
        <DropdownFilter
          options={APY_OPTIONS}
          {...filters}
          withCryptoIcon={false}
        />
      }>
      <MarketsTable
        sorting={sorting}
        p={pagination.currentPage}
        p_size={pagination.pageSize}
        order={sorting.currentSorting}
        apyOption={filters.filtersApplied['selectedOption']}
      />
    </Page>
  );
}
